import { useData } from 'vike-react/useData';
import type { Data } from './+data';
import { PillarPageRenderer } from '../../components/layout/PillarPageRenderer';

export default function CeePage() {
  const { page } = useData<Data>();
  return (
    <PillarPageRenderer
      page={page}
      pillarLabel="Primes CEE"
      pillarDescription="Mandataire CEE pour artisans RGE et entreprises — dossier monté de A à Z, dépôt sur le registre officiel des CEE, suivi du versement."
      pillarUrl="https://solutionecofrance.fr/cee"
    />
  );
}
